class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.checkTermsAccepted();
    document.addEventListener("DOMContentLoaded", () => {
      const termsBox = document.querySelector(".mini-cart--terms");
      termsBox.addEventListener("click", onTermsClicked); // use the named handler
    });
  }

  connectedCallback() {
    this.header = document.querySelector("sticky-header");
    this.drawer = document.querySelector("cart-drawer");
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }
  checkTermsAccepted() {
    console.log("checking terms");
    document.addEventListener("DOMContentLoaded", () => {
      const termsBox = document.querySelector(".mini-cart--terms");
      const cartBtn = document.querySelector(".mini-cart--button");

      // Disable the button unless the box is already checked
      cartBtn.disabled = !termsBox.checked;
    });
  }
  onTermsClicked(event) {
    const termsChecked = event.currentTarget.checked;
    document.querySelector(".mini-cart--button").disabled = !termsChecked;
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");

        document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("mini-cart", MiniCart);
